/*
 *
 * CredentialTypeList constants
 *
 */

export const RECEIVE_CREDENTIAL_TYPES = 'app/CredentialTypeList/RECEIVE_CREDENTIAL_TYPES';
